<template>
  <div class="lgrm-question-widget">
    <div class="lgrm-question">
      <slot name="question">{{ updatedQuestion }}</slot>
    </div>
    <div class="lgrm-question-options">
      <slot name="question-options"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionView',
  props: {
    question: {
      type: String,
      default: 'Your question here..'
    }
  },
  data: function() {
    return {
      value: this.selectedValue,
      vertical: false
    }
  },
  computed: {
    updatedQuestion: function() {
      if (this.brandTitle)
        return this.question.replace('{brand_name}', this.brandTitle)
      return this.question
    }
  },
  methods: {},
  beforeDestroy() {}
}
</script>

<style lang="stylus" scoped>
.lgrm-question-widget {
    width 100%
    .lgrm-question {
        font-size 16px
        color: $color-primary
        margin-bottom 20px
        text-align center
    }
    .lgrm-question-options {
        text-align center
    }
}
</style>
